import React from "react";

import Card from "./Card";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import mapBg from "../../../assets/image/map.png";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";
import Background from "../../../components/Background";
import ContentGrid from "../../../components/ContentGrid";

import style from "./style.module.css";

export default function Speaker(props) {

    const {
        enlarge_title = 0,
        speakers_title = null,
        wrap_articles = 0,
        view_all_button_label = "",
        view_all_button_link = "",
        speakers,
        card_color = "whiteBgCard",
        autoplay = false,
        show_description = 1,
        show_social_media = 1,
        delay = 10000
    } = props;

    let title = speakers_title !== null && speakers_title !== "" ? speakers_title : "Meet the Speakers";

    return (
        <>
            {
                (speakers || []).length > 0 && (
                    <Section className={`${style.speaker} ${style[card_color]}`}>
                        <div className={style.speakerWrap}>
                            <div className={`${style.sectionHelper} ${wrap_articles === 1 ? style.wrapContent : ""} ${card_color === "whiteBgCard" ? style.whiteBgCard : style.blackBgCard}`}>
                                {
                                    card_color === "whiteBgCard" && wrap_articles === 0 && (
                                        <Background src={mapBg} size="2560x1440" cPosition="bottomRight" />
                                    )
                                }
                                <div className={style.sectionRow}>
                                    <div className={`${style.sectionHeader}`}>
                                        {
                                            title !== "" && (
                                                <div className={`${style.sectionTitle}`}>
                                                    <Title
                                                        transform="uppercase"
                                                        tag={enlarge_title === 1 ? "h1" : "h4"}
                                                        className="fontTeko"
                                                    >
                                                        {title}
                                                    </Title>
                                                </div>
                                            )
                                        }
                                        {
                                            view_all_button_label !== "" && view_all_button_link !== "" && (
                                                <Link to={view_all_button_link}>{view_all_button_label}</Link>
                                            )
                                        }
                                    </div>
                                    <div className={style.sectionBody}>
                                        {
                                            (title !== "" || view_all_button_label !== "") && (
                                                <Spacer size="24" />
                                            )
                                        }
                                        {
                                            speakers.length > 0 && (
                                                <ContentGrid
                                                    items={speakers}
                                                    wrap={wrap_articles}
                                                    Component={Card}
                                                    autoplay={autoplay}
                                                    showDescription={show_description}
                                                    showSocialMedia={show_social_media}
                                                    delay={delay}
                                                    type={card_color}
                                                    col={wrap_articles === 1 ? "col4" : ""}
                                                />
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Section>
                )
            }
        </>
    )
}